<template>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <v-flex md12>
        <v-card>
          <v-toolbar dense primary-title  tile>
            <v-toolbar-title>{{$t("view.comercio.form")}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
            </v-btn>
          </v-toolbar >
          <v-slide-y-transition>
            <div v-show="view.elem.showForm">
              <v-card-text>
                <v-flex d-flex md12 >
                  <v-form>
                    <v-layout row wrap>
                      <v-flex d-flex xs12 sm6 md12>
                        <v-layout row wrap>
                          <v-flex d-flex md6>
                            <v-text-field 
                              v-show="view.elem.input.clave.visible"
                              v-if="!view.action.submit.busy" 
                              v-model="$v.comercio.clave.$model"
                              :disabled="view.elem.input.clave.disabled"
                              :error-messages="getFirstErrorDescription($v.comercio.clave)"
                              :label="$t('view.global.common.clave')" >
                            </v-text-field>
                          </v-flex>
                          <v-flex md6></v-flex>
                          <v-flex d-flex md6 >
                              <v-text-field 
                              v-model.trim="$v.comercio.numeroComercio.$model"
                              :error-messages="getFirstErrorDescription($v.comercio.numeroComercio)"
                              :label="$t('view.comercio.numeroComercio')" >
                            </v-text-field>
                          </v-flex>
                          <v-flex md6>
                            <v-text-field 
                              v-model.trim="$v.comercio.summitterId.$model"
                              :error-messages="getFirstErrorDescription($v.comercio.summitterId)"
                              :label="$t('view.comercio.summitterId')" >
                            </v-text-field>
                          </v-flex>
                          <!-- <v-flex d-flex md6 > -->
                            <!-- <v-card-text> -->
                              <v-flex d-flex md6>
                                <v-text-field
                                  v-model.trim="$v.comercio.name.$model"
                                  :error-messages="getFirstErrorDescription($v.comercio.name)"
                                  :label="$t('view.comercio.name')" >
                                </v-text-field>
                              </v-flex>
                              <v-flex d-flex md6>
                                <v-text-field
                                  v-model.trim="$v.comercio.email.$model"
                                  :error-messages="getFirstErrorDescription($v.comercio.email)"
                                  :label="$t('view.global.common.email')" >
                                </v-text-field>
                              </v-flex>
                              <v-flex d-flex md6>
                                <v-text-field
                                  v-model="$v.comercio.locationAddress.$model"
                                  :error-messages="getFirstErrorDescription($v.comercio.locationAddress)"
                                  :label="$t('view.comercio.direccion')" >
                                </v-text-field>
                              </v-flex>
                              <v-flex d-flex md6>
                                <v-text-field
                                  v-model="$v.comercio.locationCity.$model"
                                  :error-messages="getFirstErrorDescription($v.comercio.locationCity)"
                                  :label="$t('view.comercio.ciudad')" >
                                </v-text-field>
                              </v-flex>
                              <v-flex d-flex md3>
                                <v-text-field
                                  v-model="$v.comercio.locationRegionCode.$model"
                                  :error-messages="getFirstErrorDescription($v.comercio.locationRegionCode)"
                                  :label="$t('view.comercio.region')" >
                                </v-text-field>
                              </v-flex>
                              <v-flex d-flex md3>
                                <v-text-field
                                  v-model="$v.comercio.locationCountryCode.$model"
                                  :error-messages="getFirstErrorDescription($v.comercio.locationCountryCode)"
                                  :label="$t('view.comercio.codigoPais')" >
                                </v-text-field>
                              </v-flex>
                              <v-flex d-flex md3>
                                <v-text-field
                                  v-model="$v.comercio.locationPostalCode.$model"
                                  :error-messages="getFirstErrorDescription($v.comercio.locationPostalCode)"
                                  :label="$t('view.comercio.cp')" >
                                </v-text-field>
                              </v-flex>
                              <v-flex d-flex md3>
                                <v-text-field
                                  v-model="$v.comercio.consecutivoArchivosGenerados.$model"
                                  readonly
                                  :error-messages="getFirstErrorDescription($v.comercio.consecutivoArchivosGenerados)"
                                  :label="$t('view.comercio.consecutivoArchivos')" >
                                </v-text-field>
                              </v-flex>
                              <v-flex d-flex md3>
                                <v-text-field
                                  type="number"
                                  v-model="$v.comercio.mcc.$model"
                                  :error-messages="getFirstErrorDescription($v.comercio.mcc)"
                                  :label="$t('view.comercio.mcc')" >
                                </v-text-field>
                              </v-flex>
                              
                              <v-flex d-flex md12>
                                  <v-radio-group row :label="$t('view.comercio.tipoArchivo')"
                                  :error-messages="getFirstErrorDescription($v.comercio.tipoArchivo)" 
                                  v-model="$v.comercio.tipoArchivo.$model" >
                                  <div v-for="(tipoArchivo,key) in view.elem.radio.tipoArchivo.options">
                                    <v-radio  :label="tipoArchivo.name" :key="key" :value="tipoArchivo.code"></v-radio>
                                  </div>
                                  </v-radio-group>
                              </v-flex>
                              <v-flex d-flex md3>
                                  <v-switch  
                                  input-value="true" 
                                  color="primary"
                                  :label="`${$t('view.comercio.multipleSucursal')} ${$v.comercio.multipleSucursal.$model ? 'on' : 'off'}`" 
                                  v-model="$v.comercio.multipleSucursal.$model" >
                                  </v-switch>
                              </v-flex>
                              <v-flex d-flex md3>
                                  <v-switch  
                                  input-value="true" 
                                  color="primary"
                                  :label="`${$t('view.global.common.status')} ${$v.comercio.status.$model ? 'on' : 'off'}`" 
                                  v-model="$v.comercio.status.$model" >
                                  </v-switch>
                              </v-flex>
                              
                              
                            <!-- </v-card-text> -->
                          <!-- </v-flex> -->
                        </v-layout>
                      </v-flex>
                      <v-divider></v-divider>
                      <v-flex d-flex xs12 sm6 md12 >
                        <v-layout row wrap>
                          <v-flex d-flex md6 >
                            <v-card>
                              <v-toolbar dense color="secondary" dark>
                                <v-toolbar-title>{{$t("view.comercio.datosBuzonEntrada")}}</v-toolbar-title>
                              </v-toolbar>
                              <v-card-text>
                                <v-flex d-flex>
                                  <v-text-field
                                    :placeholder="$t('view.global.common.url')"
                                    prefix="sftp://"
                                    v-model="$v.comercio.urlBuzonEntrada.$model"
                                    :error-messages="getFirstErrorDescription($v.comercio.urlBuzonEntrada)"
                                    :label="$t('view.global.common.url')" 
                                    >
                                  </v-text-field>
                                </v-flex>
                                <v-flex d-flex>
                                  <v-text-field
                                    type="number"
                                    v-model="$v.comercio.puertoBuzonEntrada.$model"
                                    :error-messages="getFirstErrorDescription($v.comercio.puertoBuzonEntrada)"
                                    :label="$t('view.comercio.puerto')" 
                                    >
                                  </v-text-field>
                                </v-flex>
                                <v-flex d-flex>
                                  <v-text-field
                                    v-model="$v.comercio.usuarioBuzonEntrada.$model"
                                    :error-messages="getFirstErrorDescription($v.comercio.usuarioBuzonEntrada)"
                                    :label="$t('view.global.common.usuario')" >
                                  </v-text-field>
                                </v-flex>
                                <v-flex d-flex>
                                  <v-text-field
                                    v-model="$v.comercio.passwordBuzonEntrada.$model"
                                    type="password"
                                    :error-messages="getFirstErrorDescription($v.comercio.passwordBuzonEntrada)"
                                    :label="$t('view.global.common.contrasena')" >
                                  </v-text-field>
                                </v-flex>
                                <v-flex d-flex>
                                  <v-text-field
                                    v-model="$v.comercio.nombreArchivo.$model"
                                    :error-messages="getFirstErrorDescription($v.comercio.nombreArchivo)"
                                    :label="$t('view.comercio.nombreArchivo')" >
                                  </v-text-field>
                                </v-flex>
                                <!-- <v-layout row> -->
                                  <v-flex d-flex>
                                    <v-text-field
                                      v-model="$v.comercio.nombreArchivoGSFG.$model"
                                      :error-messages="getFirstErrorDescription($v.comercio.nombreArchivoGSFG)"
                                      :label="$t('view.comercio.nombreArchivoGSFG')" >
                                    </v-text-field>
                                  </v-flex>
                                <!-- </v-layout> -->
                              </v-card-text>
                            </v-card>
                          </v-flex>
                          <v-flex d-flex md6 >
                            <v-card>
                              <v-toolbar dense color="secondary" dark>
                                <v-toolbar-title>{{$t("view.comercio.configuracionRespuesta")}}</v-toolbar-title>
                              </v-toolbar>
                              <v-card-text>
                                <v-layout row>
                                  <v-flex md12>
                                    <v-text-field
                                      v-model="$v.comercio.nombreArchivoRespuesta.$model"
                                      :error-messages="getFirstErrorDescription($v.comercio.nombreArchivoRespuesta)"
                                      :label="$t('view.comercio.nombreArchivoRespuesta')" >
                                    </v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout row>
                                  <v-flex md12>
                                    <v-text-field
                                      v-model="$v.comercio.tiempoMaximoEsperaRespuesta.$model"
                                      type="numeric"
                                      :error-messages="getFirstErrorDescription($v.comercio.tiempoMaximoEsperaRespuesta)"
                                      :label="$t('view.comercio.tiempoMaximoEsperaRespuesta')" >
                                    </v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout row>
                                  <v-flex md12>
                                    <v-text-field
                                      v-model="$v.comercio.tiempoMaximoAdvertenciaRespuesta.$model"
                                      type="numeric"
                                      :error-messages="getFirstErrorDescription($v.comercio.tiempoMaximoAdvertenciaRespuesta)"
                                      :label="$t('view.comercio.tiempoMaximoAdvertenciaRespuesta')" >
                                    </v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout row >
                                  <v-flex  md6>
                                    <v-radio-group column :label="$t('view.comercio.formatoRespueta')"
                                    :error-messages="getFirstErrorDescription($v.comercio.formatoRespueta)" 
                                    v-model="$v.comercio.formatoRespueta.$model" >
                                      <v-radio  :label="$t('view.comercio.origen')"  value="ORIGEN"></v-radio>
                                      <v-radio  :label="$t('view.comercio.amex')"  value="AMEX"></v-radio>
                                    </v-radio-group>
                                  </v-flex>
                                  <v-flex  md6>
                                    <v-radio-group column :label="$t('view.comercio.contenidoRespuesta')"
                                    :error-messages="getFirstErrorDescription($v.comercio.contenidoRespuesta)" 
                                    v-model="$v.comercio.contenidoRespuesta.$model" >
                                      <v-radio  :label="$t('view.comercio.aprobadosRechazados')"  value="APROBADOS_RECHAZADOS"></v-radio>
                                      <v-radio  :label="$t('view.comercio.rechazados')"  value="RECHAZADOS"></v-radio>
                                    </v-radio-group>
                                  </v-flex>
                                </v-layout>
                                <v-layout row>
                                  <v-flex md12>
                                    <v-text-field
                                      v-model="$v.comercio.nombreArchivoCartRefresh.$model"
                                      :error-messages="getFirstErrorDescription($v.comercio.nombreArchivoCartRefresh)"
                                      :label="$t('view.comercio.nombreArchivoCartRefresh')" >
                                    </v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout row>
                                  <v-flex md12>
                                    <v-text-field
                                      v-model="$v.comercio.nombreArchivoCartRefreshCarga.$model"
                                      :error-messages="getFirstErrorDescription($v.comercio.nombreArchivoCartRefreshCarga)"
                                      :label="$t('view.comercio.nombreArchivoCartRefreshCarga')" >
                                    </v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-divider></v-divider>
                      <v-flex d-flex xs12 sm6 md12 >
                        <v-layout row wrap>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-flex>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-flex shrink>
                  <v-tooltip v-show="view.elem.button.clear.visible" top>
                    <v-btn 
                      @click="askForClear()" 
                      :loading="view.action.submit.busy" 
                      icon slot="activator" color="primary" large>
                      <v-icon>clear</v-icon>
                    </v-btn>
                    <span>{{$t('view.global.common.cancel')}}</span>
                  </v-tooltip>
                  <v-tooltip v-show="$userPermission.hasPermission('ROLE_AGREGAR_COMERCIO,ROLE_MODIFICAR_COMERCIO') 
                    && $v.comercio.multipleSucursal.$model &&  $v.comercio.clave.$model != null" top>
                    <v-btn 
                      @click="openSucursal($v.comercio.clave.$model)" 
                      :loading="view.action.submit.busy" 
                      icon slot="activator" color="primary" large>
                      <v-icon>mdi-cash-multiple</v-icon>
                    </v-btn>
                    <span>{{$t("view.sucursal.title")}}</span>
                  </v-tooltip>
                  <v-tooltip v-show="view.elem.button.audit.visible && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')" top>
                    <v-btn 
                      @click="showAudit()" 
                      :loading="view.action.submit.busy" 
                      icon slot="activator" color="primary" large>
                      <v-icon>storage</v-icon>
                    </v-btn>
                    <span>{{$t('view.global.common.auditoria')}}</span>
                  </v-tooltip>
                  <v-tooltip v-show="$userPermission.hasPermission(view.elem.button.submit.permission)" top>
                    <v-btn 
                      :disabled="form.$state.isDisableButtonSubmit()"
                      :loading="view.action.submit.busy" 
                      @click="submit()" 
                      color="primary"
                      icon slot="activator"  large>
                      <v-icon>check</v-icon>
                    </v-btn>
                    <span>{{submitTitle}}</span>
                  </v-tooltip>
                </v-flex>
              </v-card-actions>
            </div>
          </v-slide-y-transition>
        </v-card>
      </v-flex>
    </v-layout>
    <data-table ref="comercioTable" @editRow="loadComercio" @auditRow="showAudit" 
    @unLockRow="unLockComercio" 
    @sucursalRow="openSucursal"
    @adelantarEsperaRespuestaRow="adelantarEsperaRespuesta"
    @cambiarFechaEsperaRespuestaRow="cambiarFechaEsperaRespuesta"
    ></data-table>
    <auditoria ref="auditModal"></auditoria>
    <modal-sucursal ref="modalSucursal"></modal-sucursal>
  </v-container>
</template>
<script>
  import {required, maxLength,email,numeric, minValue,maxValue} from "vuelidate/lib/validators";
  import {allValidatorMethods} from "@/helpers/vuelidate";
  import {urlFTP, alphaNumDot, emailList, valMaxTiempoEspera, isCleanEspecialCharacter} from '@/helpers/vuelidate/validators'
  import {ComercioModel} from "@/models/generales/comercio";
  import ComercioStates from "@/views/generales/comercio/comercio-states"
  import {getErrors,getBusinessCode,getResponseDTO,handleResponseMessage} from '@/helpers/http-response-handler';
  import * as R from "ramda";
  import DataTable from "@/views/generales/comercio/DataTable";
  import ModalSucursal from "@/views/generales/comercio/ModalSucursal";
  import Auditoria from "@/components/auditoria/Auditoria";
  import VueContentLoading from 'vue-content-loading';
  import CombosAPI from "@/services/catalogos";

  //Element's Settings
  const button = {
    submit:{
      enable:true
      , text:""
      , class:{
        current:""
        , save:"button__icon icon fa fa-plus"
        , update:"button__icon icon fa fa-check"
      }
      , data:{
        title:{
          current:"",
          save:"Guardar",
          update:"Actualizar"
        }
      }
      , permission: "ROLE_AGREGAR_COMERCIO"
    }
    , clear:{
      visible:true
    }
    , audit:{
      visible:true
    }
  };
  const modal = {
    rolePrivileges:{
      htmlElement:undefined
      , modal:undefined
      , privilegioTitle:""
    }
  }
  const input = {
    clave :{
      disabled:true
      , visible: false
    }
  }
  const radio ={
    tipoArchivo:{
      options:[{name:'', code:''}]
    }
    
  }
  //Action's state
  const action = {
    submit:{
      busy:false
    }
    , privileges:{
      busy:false
    }
  };

  export default {
    name: "Comercio",
    head:{
      title:function(){
        return {
          inner       : this.view.title
          , separator : '|'
          , complement: this.$t("view.home.system.initials")
        }
      }
    }
    , data(){
      let _locale = this.$store.language;
      return {
        locale: _locale
        , comercio: undefined
        , form : new Object()
        , view:{
          title: this.$t("view.comercio.title")
          , action
          , elem:{
            button
            , modal
            , input
            , showForm: true
            , radio
          }
        }
      }
    }
    , methods: {
      ...allValidatorMethods
      , async submit(){
        try{        
          const respuesta = await this.form.$state.submit(this.comercio);
          const responseDTO = getResponseDTO(respuesta);
          handleResponseMessage({response: respuesta,modulo:this.name})
          this.form.$setState('editing',responseDTO.comercio);
        }catch(error){
        }
      }
      , askForClear(){
        this.form.$state.askForClear();
      }
      , async showAudit(id=this.comercio.clave,dataDescripcion=this.comercio.name){

        this.$refs.auditModal.loadAudit({clave:id,tabla:'TComercio',descripcion:dataDescripcion,revision:null});
      }
      , async loadComercio(idComercio){
        try{
          const respuesta = await this.form.$state.load({clave:idComercio});
          const responseDTO = getResponseDTO(respuesta);
          //handleResponseMessage({response: respuesta,modulo:this.name})
          this.form.$setState('editing',responseDTO.comercio)
        }catch(error){
          // console.log(error)
        }
      }
      , async loadTipoArchivos (){
        const responseCombosTipoArchivos = await CombosAPI.get({tipo:'tipoArchivos'});
        this.view.elem.radio.tipoArchivo.options = responseCombosTipoArchivos.data.results.combo;
      }
      , async unLockComercio(idComercio){
        try{
          const swalResponse = await this.$swal({
            title: this.$t('view.global.swal.unlockComercio.title')
            , text: this.$t('view.global.swal.unlockComercio.text')
            , type: this.$t('view.global.swal.unlockComercio.type')
            , showCancelButton: this.$t('view.global.swal.unlockComercio.showCancelButton')
            , confirmButtonColor: this.$t('view.global.swal.unlockComercio.confirmButtonColor')
            , cancelButtonColor: this.$t('view.global.swal.unlockComercio.cancelButtonColor')
            , confirmButtonText: this.$t('view.global.swal.unlockComercio.confirmButtonText')
            , cancelButtonText: this.$t('view.global.swal.unlockComercio.cancelButtonText')
            , reverseButtons: true
          });
          if(swalResponse.value){
            const respuesta = await this.form.$state.unlock({clave:idComercio});
            const responseDTO = getResponseDTO(respuesta);
            handleResponseMessage({response: respuesta,modulo:this.name})
          }
          
        }catch(error){
          console.log(error)
        }
      }
      , async adelantarEsperaRespuesta(idComercio){
        try{
           console.log("emitAdelantarEsperaRespuesta2");
          const swalResponse = await this.$swal({
            title: this.$t('view.global.swal.adelantarEsperaRespuesta.title')
            , text: this.$t('view.global.swal.adelantarEsperaRespuesta.text')
            , type: this.$t('view.global.swal.adelantarEsperaRespuesta.type')
            , showCancelButton: this.$t('view.global.swal.adelantarEsperaRespuesta.showCancelButton')
            , confirmButtonColor: this.$t('view.global.swal.adelantarEsperaRespuesta.confirmButtonColor')
            , cancelButtonColor: this.$t('view.global.swal.adelantarEsperaRespuesta.cancelButtonColor')
            , confirmButtonText: this.$t('view.global.swal.adelantarEsperaRespuesta.confirmButtonText')
            , cancelButtonText: this.$t('view.global.swal.adelantarEsperaRespuesta.cancelButtonText')
            , reverseButtons: true
          });
          if(swalResponse.value){
            const respuesta = await this.form.$state.adelantarEsperaRespuesta({clave:idComercio});
            const responseDTO = getResponseDTO(respuesta);
            handleResponseMessage({response: respuesta,modulo:this.name})
          }
          
        }catch(error){
          console.log(error)
        }
      }
      , async cambiarFechaEsperaRespuesta(idComercio){
        try{
           console.log("cambiarFechaEsperaRespuesta2");
          const swalResponse = await this.$swal({
            title: this.$t('view.global.swal.cambiarFechaEsperaRespuesta.title')
            , text: this.$t('view.global.swal.cambiarFechaEsperaRespuesta.text')
            , type: this.$t('view.global.swal.cambiarFechaEsperaRespuesta.type')
            , showCancelButton: this.$t('view.global.swal.cambiarFechaEsperaRespuesta.showCancelButton')
            , confirmButtonColor: this.$t('view.global.swal.cambiarFechaEsperaRespuesta.confirmButtonColor')
            , cancelButtonColor: this.$t('view.global.swal.cambiarFechaEsperaRespuesta.cancelButtonColor')
            , confirmButtonText: this.$t('view.global.swal.cambiarFechaEsperaRespuesta.confirmButtonText')
            , cancelButtonText: this.$t('view.global.swal.cambiarFechaEsperaRespuesta.cancelButtonText')
            , reverseButtons: true
          });
          if(swalResponse.value){
            const respuesta = await this.form.$state.cambiarFechaEsperaRespuesta({clave:idComercio});
            const responseDTO = getResponseDTO(respuesta);
            handleResponseMessage({response: respuesta,modulo:this.name})
          }
          
        }catch(error){
          
          console.log(error)
        }
      }
      ,async openSucursal(idComercio){
        try{
          const respuesta = await this.form.$state.load({clave:idComercio});
          const responseDTO = getResponseDTO(respuesta);
          this.$refs.modalSucursal.openDialog(responseDTO.comercio);
        }catch(error){
          console.error(error)
        }
        
      }
    }
    , computed:{
      submitClass(){
        return this.view.elem.button.submit.class.current
      },
      submitTitle(){

        return this.view.elem.button.submit.data.title.current
      }
    }
    , validations:{
      comercio:{
        clave:{
          required:false
        }
        , name:{
          required
          , maxLength : maxLength(200)
          , isCleanEspecialCharacter
        }
        , email:{
          required
          , emailList:emailList(';')
          , maxLength : maxLength(1000)
          
        }
        , tipoArchivo:{
          required
        }
        , status:{
          required
        }
        , urlBuzonEntrada:{
          required
        }
        ,usuarioBuzonEntrada:{
          required
        }
        ,passwordBuzonEntrada:{
          required
        }
        // , urlBuzonRecepcion:{
        //   required
        //   // , urlFTP
        // }
        // ,usuarioBuzonRecepcion:{
        //   required
        // }
        // ,passwordBuzonRecepcion:{
        //   required
        // }
        ,puertoBuzonEntrada:{
          required
          , numeric
        }
        // ,puertoBuzonRecepcion:{
        //   required
        //   , numeric
        // }
        ,locationAddress:{
          required
          , isCleanEspecialCharacter
        }
        ,locationCity:{
          required
        }
        ,locationRegionCode:{
          required
          /* , numeric */
        }
        ,locationCountryCode:{
          required
          , numeric
        }
        ,locationPostalCode:{
          required
          
        }
        ,consecutivoArchivosGenerados:{
          numeric
        }
        ,numeroComercio:{
          required
          , numeric
        }
        , tiempoMaximoEsperaRespuesta:{
          required
          , numeric
          , minValue: minValue(1)
          , maxValue: maxValue(24)
        }
        , tiempoMaximoAdvertenciaRespuesta:{
          required
          , numeric
          , minValue: minValue(1)
          , maxValue: maxValue(24)
          , valMaxTiempoEspera: valMaxTiempoEspera('tiempoMaximoAdvertenciaRespuesta')
        }
        , formatoRespueta:{
          required
        }
        ,contenidoRespuesta:{
          required
        }
        , summitterId:{
          required
          , alphaNumDot
        }
        , nombreArchivo:{
          required
        }
        , nombreArchivoGSFG:{
          required
        }
        , nombreArchivoRespuesta:{
          required
        }
        , mcc:{
          required
          , maxLength: maxLength(4)
        }
        , multipleSucursal:{
          required
        }
        , sucursalEnEspera:{
          
        }
        , nombreArchivoCartRefresh:{
          
        }
        , nombreArchivoCartRefreshCarga:{
          
        }
      }
    }
    , components: {
      VueContentLoading
      , DataTable
      , Auditoria 
      , ModalSucursal
    } 
    , created(){
      try{
        this.loadTipoArchivos()
        this.form = new ComercioStates(this);
        this.form.$setState('initial');
      }catch(e){

      }
      
    }
  }
</script>

<style>
.v-text-field__prefix {
    width: 50px !important;
    text-align: right;
    padding-right: 4px;
}
</style>




// WEBPACK FOOTER //
// src/views/generales/comercio/Comercio.vue